import {
  ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_FAILURE,
  ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_REQUEST,
  ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_SUCCESS,
  FETCH_CALIX_NETWORKS_CUSTOMER_LIST_FAILURE,
  FETCH_CALIX_NETWORKS_CUSTOMER_LIST_REQUEST,
  FETCH_CALIX_NETWORKS_CUSTOMER_LIST_SUCCESS,
} from "./actionTypes";
import { CalixNetworksCustomerState } from "./types";

const initialCustomerState: CalixNetworksCustomerState = {
  calixNetworksCustomersList: [],
  loading: false,
  error: null,
  totalCount: 0,
  successMessage: null,
};

const calixNetworksCustomerReducer = (
  state = initialCustomerState,
  action: any,
): CalixNetworksCustomerState => {
  switch (action.type) {
    case FETCH_CALIX_NETWORKS_CUSTOMER_LIST_REQUEST:
    case ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CALIX_NETWORKS_CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        calixNetworksCustomersList:
          action.payload.calixNetworksCustomerList || action.payload,
        totalCount: action.payload.totalCount || 0,
      };

    case FETCH_CALIX_NETWORKS_CUSTOMER_LIST_FAILURE:
    case ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_UPDATE_CALIX_NETWORKS_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload.successMessage,
      };

    default:
      return state;
  }
};

export default calixNetworksCustomerReducer;
